 <template>
  <div>
    <div
      class="modal fade right create_event_modal"
      id="crete_eventModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="create-event-popup-header position-relative">
              <h4>Select a Playbook from below</h4>
              <div class="cross-button" data-dismiss="modal" aria-label="Close">
                <v-icon color="#333" size="30px">mdi-close</v-icon>
              </div>
            </div>
            <div class="create-event-options">
              <div
                class="
                  template-shimmers
                  d-flex
                  justify-content-between
                  align-items-center
                "
                v-if="defaultTemplates.length == 0"
              >
                <div class="blank-template-shimmer shine2"></div>
                <div class="blank-template-shimmer shine2"></div>
                <div class="blank-template-shimmer shine2"></div>
              </div>
              <ul>
                <li
                  v-for="template in defaultTemplates"
                  :key="template.TemplateId"
                  :id="'OA_UAT_' + template.ClientId + template.EventId"
                >
                  <div
                    v-if="template"
                    :class="
                      template && template.TemplateId == 1
                        ? 'single-event-option'
                        : 'disable-event-template single-event-option'
                    "
                    @click="
                      template.EventId != '' && template.TemplateId == 1
                        ? openCreateEventDialog(template)
                        : ''
                    "
                  >
                    <div class="event-logo-ico">
                      <img :src="template.TemplateLogo" />
                    </div>
                    <p>{{ template.EventFullName }}</p>
                  </div>
                </li>
                <!-- <li>
                  <div
                    :class="
                      template && template.TemplateId == 2
                        ? 'single-event-option'
                        : 'disable-event-template single-event-option'
                    "
                    @click="
                      template && template.TemplateId == 2
                        ? openCreateEventDialog(template)
                        : ''
                    "
                  >
                    <div class="event-logo-ico">
                      <img src="../assets/Images/community-event.png" />
                    </div>
                    <p>Community Event</p>
                  </div>
                </li>
                <li>
                  <div
                    :class="
                      template && template.TemplateId == 3
                        ? 'single-event-option'
                        : 'disable-event-template single-event-option'
                    "
                    data-toggle="modal"
                    @click="
                      template && template.TemplateId == 3
                        ? openCreateEventDialog(template)
                        : ''
                    "
                  >
                    <div class="event-logo-ico">
                      <img src="../assets/Images/employee-event.png" />
                    </div>
                    <p>Employee Event</p>
                  </div>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade create_employee_modal"
      id="create_employee_ModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="create-employee-head position-relative">
              <!-- <h2>Create New {{ displayName }}</h2> -->
              <h2>Create New</h2>
              <div class="cross-button" data-dismiss="modal" aria-label="Close">
                <v-icon color="#333" size="30px">mdi-close</v-icon>
              </div>
            </div>
            <div class="create-employee-event">
              <!-- <div class="form-group empty-error"> -->

              <label>Event Name*</label>

              <input
                type="text"
                name="name"
                :class="
                  showErrorMsg
                    ? 'event-name-big-field empty-error'
                    : 'event-name-big-field'
                "
                v-model="eventName"
                :placeholder="displayName"
                required="required"
                id="eventNameFocus"
              />

              <span class="d-block mb-4" v-if="showErrorMsg">
                <v-icon color="red">info</v-icon>This field is required</span
              >

              <!-- </div> -->
              <label>Time Zone*</label>

              <select class="form-control" v-model="defaultUserTimeZone">
                <option
                  v-for="(item, index) in timeZones"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.label }}
                </option>
              </select>
              <ul>
                <li>
                  <label>Event Starts</label>

                  <input
                    type="date"
                    name="sCalender"
                    id="startCalender"
                    v-model="defaultUserStartDate"
                  />
                </li>
                <li>
                  <label>Start Time</label>
                  <input type="time" name="" v-model="defaultUserStartTime" />
                </li>
                <li>
                  <label>Event Ends</label>
                  <input type="date" name="" v-model="defaultUserEndDate" />
                </li>
                <li>
                  <label>End Time</label>
                  <input type="time" name="" v-model="defaultUserEndTime" />
                </li>
              </ul>
              <div class="save-div">
                <v-btn
                  outlined
                  color="#959595"
                  width="100px"
                  class="mr-2"
                  @click="closeDialog()"
                  >Cancel</v-btn
                >
                <v-btn
                  dark
                  color="#1a73e8"
                  width="100px"
                  @click="saveNewAdminEvent()"
                  >Save</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import jQuery from "jquery";
let $ = jQuery;
import axios from "axios";
import APIs from "@/components/APIInit";
import common from "@/common";
import moment from "moment";
import router from "../router";
import { bus } from "@/main";
import store from "../store";

export default {
  data() {
    return {
      showErrorMsg: false,
      defaultTemplates: [
        {
          ClientId: "",
          EventId: "",
          EventFullName: "Webinar event",
          EventShortName: "Webinar event",
          TemplateDisplayOrder: 1,
          TemplateId: 1,
          TemplateLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FTemplates%2Fwebinar-event-logo.png?alt=media",
        },
        {
          ClientId: "",
          EventId: "",
          EventFullName: "Community Event",
          EventShortName: "Community Event",
          TemplateDisplayOrder: 2,
          TemplateId: 2,
          TemplateLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FTemplates%2Fcommunity-event-logo.png?alt=media",
        },
        {
          ClientId: "",
          EventId: "",
          EventFullName: "Employee event",
          EventShortName: "Employee event",
          TemplateDisplayOrder: 3,
          TemplateId: 3,
          TemplateLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FTemplates%2Fwebinar-event-logo.png?alt=media",
        },
      ],
      eventName: null,
      displayName: null,
      eventId: null,
      clientId: null,
      timeZones: [],
      defaultUserTimeZone: null,
      defaultUserStartDate: null,
      defaultUserEndDate: null,
      defaultUserStartTime: null,
      defaultUserEndTime: null,
      defaultTemplateClientId: null,
    };
  },
  components: {},
  props: {
    value: Boolean,
  },
  methods: {
    closeDialog() {
      this.eventName = null;
      $("#crete_eventModalCenter").modal("hide");
      $("#create_employee_ModalCenter").modal("hide");
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    saveNewAdminEvent() {
      if (this.eventName != null) {
        this.showErrorMsg = false;
        bus.$emit("toggleLoader", true);
        var headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + this.getSessionToken(),
        };

        var startDateInitial =
          this.defaultUserStartDate + " " + this.defaultUserStartTime;

        var endDateInitial =
          this.defaultUserEndDate + " " + this.defaultUserEndTime;

        var startD = this.GetTimeByZone(
          startDateInitial,
          this.defaultUserTimeZone
        );
        var endD = this.GetTimeByZone(endDateInitial, this.defaultUserTimeZone);

        var requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: this.defaultTemplateClientId, //self.clientID,
            eventId: this.eventId,
            targetClientId: this.clientId,
          },
          data: {
            EventFullName: this.eventName,
            EventShortName: this.eventName,
            EventStartDate: startD,
            EventEndDate: endD,
            TimeZone: this.defaultUserTimeZone,
          },
        };

        axios
          .post(APIs.CloneEvent, JSON.stringify(requestData), {
            headers: headers,
          })
          .then((response) => {
            if (response.data.status == 0) {
              var eventDetails = {
                EventFullName: this.eventName,
                EventStartDate: startD,
                EventEndDate: endD,
                TimeZone: this.defaultUserTimeZone,
                DocPath: response.data.statusDoc,
              };
              store.commit("setTempAdminEvent", eventDetails);
              this.eventName = null;
              bus.$emit("toggleLoader", false);
              $("#create_employee_ModalCenter").modal("hide");
              router.push("/eventoverview#ManageMyEvents");
            }
          })
          .catch((error) => {
            debugger;
            //self.IsSubmitting = false;
            console.log("Error:" + error);
          });
      } else {
        this.showErrorMsg = true;
      }
    },
    fetchTemplateDetails() {
      const token = this.getSessionToken();

      axios
        .get(APIs.GetEventTemplates, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          res.data.events.map((data) => {
            this.defaultTemplates.map((template) => {
              if (data.TemplateId == template.TemplateId) {
                template.EventId = data.EventId;
                template.ClientId = data.ClientId;
              }

              // this.defaultTemplates.push(data);
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openCreateEventDialog(template) {
      // this.eventName = template.EventFullName;
      this.displayName = template.EventFullName;
      this.eventId = template.EventId;
      this.clientId = this.$store.state.client[0].id;
      this.defaultUserTimeZone = moment.tz.guess();
      this.defaultUserStartDate = moment().format("YYYY-MM-DD");
      this.defaultUserEndDate = moment().format("YYYY-MM-DD");
      this.defaultUserStartTime = moment().add(1, "hour").startOf('hour').format("HH:mm");
      this.defaultUserEndTime = moment().add(2, "hour").startOf('hour').format("HH:mm");

       if(this.defaultUserStartTime > this.defaultUserEndTime){
         this.defaultUserEndDate = moment().add(1, "day").format("YYYY-MM-DD");

       }
       


      this.defaultTemplateClientId = template.ClientId;

      $("#crete_eventModalCenter").modal("hide");
      $("#create_employee_ModalCenter").modal("show");

        setTimeout(() => {
        document.getElementById("eventNameFocus").focus();
      }, 500);
    },
  },
  mounted() {
    this.fetchTemplateDetails();
    if (this.value) {
      $("#crete_eventModalCenter").modal("show");
    }

    this.timeZones = [{ label: "Select TimeZone", value: "" }].concat(
      common.getTimeZones()
    );
  },
};
</script>
<style>
.disable-event-template {
  opacity: 0.5;
}
</style>